import React from "react";
import PropTypes from "prop-types";
import styles from "./MainNav.module.less";

const ActivityCenter = ({
  width = "19",
  height = "18",
  fill = "var(--royal-peacock-blue)",
  active = false,
  hovered = false,
}) => {
  return (
    <div
      className={[active ? styles.navIconContainerActive : styles.navIconContainer, hovered ? styles.hovered : []].join(
        " ",
      )}
      style={{
        padding: "0 0px 1px 1px",
      }}
    >
      <svg width={width} height={height} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.03149 0.0010376C5.52781 0.0010376 5.93108 0.404301 5.93108 0.900624V1.80124H13.1298V0.900624C13.1298 0.404301 13.533 0.0010376 14.0294 0.0010376C14.5278 0.0010376 14.9311 0.404301 14.9311 0.900624V1.80124H15.8307C17.3217 1.80124 18.5294 3.01 18.5294 4.50104V7.20083C18.5294 7.69715 18.1261 8.10042 17.6298 8.10042H14.9311C12.4453 8.10042 10.4311 10.1147 10.4311 12.5994V17.0994C10.4311 17.5967 10.0278 17.9989 9.53149 17.9989H3.23025C2.49198 17.9989 1.82193 17.7023 1.33595 17.2213C0.839629 16.7323 0.531494 16.052 0.531494 15.2992V4.5C0.531494 3.00897 1.73922 1.80124 3.23025 1.80124H4.1319V0.900624C4.1319 0.404301 4.5331 0.0010376 5.03149 0.0010376ZM3.17855 5.16901C3.17855 5.04803 3.21992 4.93635 3.28816 4.8464C3.38536 4.72025 3.53632 4.6396 3.70796 4.6396H15.3551C15.6466 4.6396 15.8845 4.87638 15.8845 5.16901V5.69842C15.8845 5.99104 15.6466 6.22783 15.3551 6.22783H3.70796C3.41637 6.22783 3.17855 5.99104 3.17855 5.69842V5.16901ZM3.70796 7.75196C3.41637 7.75196 3.17855 7.98874 3.17855 8.28137V8.81078C3.17855 8.92348 3.21371 9.02792 3.27369 9.11374C3.33779 9.20474 3.43085 9.27505 3.53839 9.31124C3.59216 9.32985 3.64799 9.34019 3.70796 9.34019H8.31137C8.60502 9.34019 8.84078 9.10341 8.84078 8.81078V8.28137C8.84078 7.98874 8.60502 7.75196 8.31137 7.75196H3.70796ZM3.27781 11.0846C3.37501 10.9512 3.53219 10.8643 3.70796 10.8643H8.31137C8.60502 10.8643 8.84078 11.1011 8.84078 11.3937V11.9231C8.84078 12.0586 8.78908 12.1827 8.70636 12.2758C8.60916 12.3843 8.46854 12.4525 8.31137 12.4525H3.70796C3.41637 12.4525 3.17855 12.2158 3.17855 11.9231V11.3937C3.17855 11.278 3.21578 11.1714 3.27781 11.0846ZM11.7154 12.2995C11.7154 10.5086 13.1257 9 14.9311 9C16.7364 9 18.1448 10.5086 18.1448 12.2995V14.7367L18.2771 14.8752C18.3682 14.9693 18.4364 15.082 18.4798 15.203C18.5129 15.2971 18.5294 15.3974 18.5294 15.4998V16.2991C18.5294 16.7964 18.1261 17.1996 17.6298 17.1996H16.3477C16.0561 17.6733 15.5432 17.9989 14.9311 17.9989C14.3189 17.9989 13.804 17.6733 13.5124 17.1996H12.2303C11.7339 17.1996 11.3307 16.7964 11.3307 16.2991V15.4998C11.3307 15.2661 11.4216 15.0427 11.583 14.8752L11.7154 14.7367V12.2995Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

ActivityCenter.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  active: PropTypes.bool,
  hovered: PropTypes.bool,
};

export default ActivityCenter;
